import { useMemo } from "react";
import { PriceInterface } from "../store/interfaces";

export default function useItemPrice(price: PriceInterface, currency: string, isDiscountApplied = true) {
  return useMemo(() => {
    if (isDiscountApplied) {
      return {
        amount: price.amount,
        old_amount: price.old_amount ? price.old_amount : null,
        currency,
      };
    }

    return {
      amount: price.old_amount ? price.old_amount : price.amount,
      old_amount: price.old_amount ? price.old_amount : null,
      currency,
    }
  }, [isDiscountApplied, price, currency]);
}
